import { Box, TextInput } from '@primer/react';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ComboboxPhongNamHoc from '../../components/combobox-phong-nam-hoc';
import Text from "../../components/ui/text";
import { useCommonContext } from '../../contexts/common';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { IPhongDiemDanhResponse } from '../../models/response/diem-danh/IPhongDiemDanhResponse';
import DiemDanh from "./DiemDanh";
const defaultLopDiemDanh: IPhongDiemDanhResponse = {
    phong_nam_hoc_id: 0,
    dm_truong_id: 0,
    nt_thoi_khoa_bieu_chi_tiet_id: 0,
    nt_tiet_id: 0,
    ten_phong: '',
    gio_diem_danh: ''
}
const DiemDanhHangNgayPage = () => {
    const { translate, checkAccesiableTo } = useCommonContext();
    const { tab } = useParams();
    const { nam_hoc, dm_he_id, dm_truong_id } = useCommonSelectedHook();
    const [ngay_diem_danh, setNgayDiemDanh] = useState(moment().format());
    const [phongDiemDanh, setPhongDiemDanh] = useState<IPhongDiemDanhResponse>(defaultLopDiemDanh);
    const [phongDiemDanhId, setPhongDiemDanhId] = useState<number>(0);
    const navigate = useNavigate();

    return (
        <Box sx={{
            // p: 2
        }}>
            <Box id="toolbar" sx={{
                display: "flex",
                backgroundColor: "canvas.subtle",
                p: 2,
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: "border.default",
                alignItems: "center"
            }}>
                {/* <Box>
                    <SegmentedControl aria-label="File view" size='small'>
                        <SegmentedControl.Button
                            selected={selectedTab === "diem-danh"}
                            onClick={() => {
                                navigate("../../diem-danh-hang-ngay/diem-danh")
                            }}
                        >
                            {translate("DiemDanhPage.Caption")}
                        </SegmentedControl.Button>
                        <SegmentedControl.Button
                            selected={selectedTab === "nhan-xet"}
                            onClick={() => {
                                navigate("../../diem-danh-hang-ngay/nhan-xet")
                            }}
                        >
                            {translate("NhanXetHangNgayPage.Caption")}
                        </SegmentedControl.Button>
                    </SegmentedControl>
                </Box> */}
                <Box sx={{ ml: 1 }}>
                    <TextInput
                        leadingVisual={<Box>
                            <Text text="Base.Label.Date" />
                        </Box>}
                        type='date'
                        value={moment(ngay_diem_danh).format("YYYY-MM-DD")}
                        onChange={(e) => {
                            const dateSelected = e.target.value ? moment(e.target.value).format() : moment().format();
                            setNgayDiemDanh(dateSelected);
                            // setPhongDiemDanh(defaultLopDiemDanh)
                        }}
                    />
                </Box>
                <Box sx={{ ml: 1 }}>
                    <ComboboxPhongNamHoc
                        onValueChanged={(dm_phong_id, phongs) => {
                            setPhongDiemDanh({
                                ...defaultLopDiemDanh,
                                phong_nam_hoc_id: dm_phong_id,
                            })
                            setPhongDiemDanhId(dm_phong_id ?? 0);
                        }}
                        value={phongDiemDanhId}

                    />

                </Box>
                <Box sx={{
                    flex: 1
                }}>

                </Box>
            </Box>
            <Box sx={{
                // p: 3,
                pb: 0
            }}>
                <Box sx={{ p: 3 }}>
                    <DiemDanh
                        date={ngay_diem_danh}
                        phongDiemDanh={phongDiemDanh}
                    />
                </Box>
            </Box>

        </Box>
    );
};

export default DiemDanhHangNgayPage;